import styled from 'styled-components';
import { TableTitleMixin } from '@qover/typography';

export const Container = styled.div`
  color: var(--color-text-quote-30);
  font-weight: bold;
  display: flex;

  > :nth-child(2) {
    margin-left: 10px;
  }

  span {
    text-decoration: line-through solid currentColor;
    display: inline-flex;
    align-items: center;
  }

  svg {
    fill: currentColor;
  }

  &.included {
    span {
      cursor: pointer;
      color: var(--color-text-quote-100);
      border-bottom: 1px dashed var(--color-primary-100);
      text-decoration: none;
    }

    svg {
      fill: var(--color-primary-100);
    }
  }
`;

export const BikeIconContainer = styled.li<{ icon: any }>`
  ${TableTitleMixin};
  ${props => props.icon()};
  background-position: left top;
  background-repeat: no-repeat;
  background-size: 20px 20px;
  color: ${props => props.theme.colors.textQuote(0.3)};
  font-weight: bold;
  line-height: normal;
  padding-left: 30px;
  position: relative;

  &&& {
    margin: 10px 0 0;
    padding-top: 0;
  }

  span {
    color: ${props => props.theme.colors.textQuote()};
    text-decoration: none;
  }
`;
